import {css} from "@emotion/css";
import {Box, Grid, LinearProgress} from "@mui/material";
import React, {useState} from "react";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";


const UploadPhoto = (
    {
        photo,
        setPhoto,
        photoFile,
        setPhotoFile,
        hidePhotoUploadLoading,
        setHidePhotoUploadLoading,
        progressPhoto,
        setProgressPhoto,
        bufferPhoto,
        setBufferPhoto,
    }) => {


    function uploadPhotoFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setPhotoFile(files[0])
            // setPhotoName(files[0].name)
            setPhoto(URL.createObjectURL(files[0]))
        }
    }

    return (
        <section>
            <Box className="d-flex flex-column flex-grow-1 w-100 h-100" sm={12}>
                <Grid sm={12} className={css`
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  height: 100%;
                  gap: 8px;
                `}>
                    <input
                        type="file"
                        id="uploadPhotoFile"
                        hidden={true}
                        multiple={true}
                        accept="image/png,image/gif,image/jpeg"
                        onChange={uploadPhotoFile}
                    />
                    <div className="uploadImageContent"
                         onDragOver={event => {
                             event.stopPropagation();
                             event.preventDefault();
                             event.dataTransfer.dropEffect = 'copy';
                         }}
                         onDrop={event => {
                             event.stopPropagation();
                             event.preventDefault();
                             uploadPhotoFile({target: {files: event.dataTransfer.files}})
                         }}
                         id="uploadPhotoContent"
                    >
                        <div className="d-flex alignItemsCenter">
                            {
                                photo ?
                                    <img
                                        className={css`
                                          object-fit: fill;
                                          max-width: 25%;
                                        `}
                                        src={photo}
                                        alt=""/> :
                                    <div className="ic-picture"/>
                            }
                            <div className="upload-text-content">
                                <span className="upload-text">آپلود تصویر</span>
                                <span className="drop-down-text">تصویر را به اینجا بکشید.</span>
                            </div>
                        </div>
                        <ButtonPrimaryRaiko
                            className={css`white-space: nowrap;padding:0 .5rem;`}
                            label={"انتخاب فایل"}
                            onClick={_ => document.getElementById("uploadPhotoFile").click()}/>
                    </div>
                    <div className={`${hidePhotoUploadLoading ? "d-none" : "d-block"}`}>
                        <LinearProgress

                            hidden={hidePhotoUploadLoading}
                            className='w-100 mt-2'
                            variant="buffer"
                            value={progressPhoto}
                            valueBuffer={bufferPhoto}/>
                    </div>

                </Grid>

            </Box>
        </section>
    )
}
export default UploadPhoto